import React, { useEffect } from 'react';
import {
  StatsigProvider as Provider,
  useClientAsyncInit,
} from '@statsig/react-bindings';
import { getAuth } from 'firebase/auth';

import { getDataFromCookie } from '@sayido/utils';

import Loading from './Loading';

import environment from '../constants/environment';
const { APP_VERSION = 'none' } = process.env;

export default function StatsigProvider({ children }) {
  // initialize user as undefined following the docs: https://docs.statsig.com/guides/first-device-level-experiment/#step-2-initialize-the-sdk-in-your-application
  const userData = getDataFromCookie('userData');
  const statsigUser = {
    userID: userData?.uid,
    email: userData?.email,
    customIDs: {
      stableID: userData?.stableID,
    },
    custom: {
      appVersion: APP_VERSION,
      pagePath: typeof window !== 'undefined' ? window.location.pathname : '',
      source: 'AppProviders-Content',
      registration_date: userData?.registration_date ?? new Date().toISOString(),
    },
  };

  const { client, isLoading } = useClientAsyncInit(
    environment.statsigClientKey,
    statsigUser,
    { environment: { tier: environment.name } }
  );

  useEffect(() => {
    // Listen for auth state changes
    const auth = getAuth();
    return auth.onAuthStateChanged(firebaseUser => {
      if (firebaseUser) {
        client.updateUserAsync({
          userID: firebaseUser.uid,
          custom: {
            registration_date: firebaseUser.metadata.creationTime,
          },
        });
      }
    });
  }, [client]);

  if (isLoading) {
    return <Loading />;
  }

  return <Provider client={client}>{children}</Provider>;
}
